import { useEffect, useState } from "react";
import { Box, Typography, Stack } from "@mui/material";
import ActionButton from "../account/ActionButton";
import ScrollToTop from "../nav/ScrollToTop";
import SfsCategoryButton from "./SfsCategoryButton";
import SfsSummary from "./SfsSummary";
import SfsInputRow from "./SfsInputRow";
import SfsTriggerFigureCheckbox from "./SfsTriggerFigureCheckbox";
import { useSfs } from "../../context/SfsProvider";
import { useClient } from "../../context/ClientProvider";

function SfsExpenditureFlexible({ handleNext, handleBack }) {
  /* The flexible expenditure component */
  const [disableNext, setDisableNext] = useState(false)
  const [commsCheckEnabled, setCommsCheckEnabled] = useState(null)
  const [personalCheckEnabled, setPersonalCheckEnabled] = useState(null)
  const [foodCheckEnabled, setFoodCheckEnabled] = useState(null)
  const [displayCommsTriggerFigure, setDisplayCommsTriggerFigure] = useState(false)
  const [displayPersonalTriggerFigure, setDisplayPersonalTriggerFigure] = useState(false)
  const [displayFoodTriggerFigure, setDisplayFoodTriggerFigure] = useState(false)
  const [commsTriggerLimit, setCommsTriggerLimit] = useState(0)
  const [personalTriggerLimit, setPersonalTriggerLimit] = useState(0)
  const [foodTriggerLimit, setFoodTriggerLimit] = useState(0)
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();
  const {
    sfsExpenditureFlexible,
    setSfsExpenditureFlexible,
    setSfsCategoryTotal,
    categories,
    setCategories,
    changeCategory,
    selectedCategory,
    setSelectedCategory,
    flexValue,
    household,
    sfsTotals
  } = useSfs();


  const setItem = (newItem) => {
    const newExpenditureFlexibleValues = sfsExpenditureFlexible.map((item) =>
      item.category === newItem.category && item.title === newItem.title
        ? newItem
        : item
    );
    setSfsExpenditureFlexible(newExpenditureFlexibleValues);
    setSfsCategoryTotal(newItem, newExpenditureFlexibleValues);
  };

  const calculateTriggerFigureLimit = (adults, childrenUnder16, children16to18, triggerFigureConfig, expenditureType) => {
    const filteredConfig = triggerFigureConfig.filter((ele) => ele.name === expenditureType)[0];
    const triggerFigureLimit = filteredConfig?.firstAdult + (filteredConfig?.additionalAdult * (adults - 1)) + (filteredConfig?.children16to18 * children16to18) + (filteredConfig?.childrenUnder16 * childrenUnder16);
    return triggerFigureLimit
  };

  const displayTriggerFigureCheckbox = (expenditureType, triggerFigureLimit) => {
    const totalCategoryExpenditure = sfsTotals.categories.filter((obj) => obj.name === expenditureType)[0].value;
    if (totalCategoryExpenditure > triggerFigureLimit) {
      return true
    }
    else {
      return false
    }
  };

  const titleText = (
    <span>
      {" "}
      <b>Monthly Expenditure Summary -</b> Flexible
    </span>
  );

  useEffect(() => {
    // Set data to flexible expenditure data on load
    if (sfsExpenditureFlexible) {
      // Get unique array of categories in data
      const uniqueCategoryList = sfsExpenditureFlexible
        .map((item) => item.category)
        .filter((value, index, self) => self.indexOf(value) === index);
      // Convert categories to objects with selected flag
      const uniqueCategories = uniqueCategoryList.map((item, idx) => ({
        name: item,
        selected: idx === 0 ? true : false,
      }));
      setCategories(uniqueCategories);
      setSelectedCategory(uniqueCategories[0].name);
      setCommsTriggerLimit(calculateTriggerFigureLimit(household[0].value, household[1].value, household[2].value, clientConfig?.layout?.sfs?.triggerFigures, "Communications & Leisure"))
      setDisplayCommsTriggerFigure((displayTriggerFigureCheckbox("Communications & Leisure", commsTriggerLimit)));
      setDisplayPersonalTriggerFigure(displayTriggerFigureCheckbox("Personal Costs", personalTriggerLimit))
      setPersonalTriggerLimit(calculateTriggerFigureLimit(household[0].value, household[1].value, household[2].value, clientConfig?.layout?.sfs?.triggerFigures, "Personal Costs"))
      setDisplayFoodTriggerFigure(displayTriggerFigureCheckbox("Food & Housekeeping", foodTriggerLimit))
      setFoodTriggerLimit(calculateTriggerFigureLimit(household[0].value, household[1].value, household[2].value, clientConfig?.layout?.sfs?.triggerFigures, "Food & Housekeeping"))
    }
  }, []);

  useEffect(() => {
    setCommsTriggerLimit(calculateTriggerFigureLimit(household[0].value, household[1].value, household[2].value, clientConfig?.layout?.sfs?.triggerFigures, "Communications & Leisure"))
    setDisplayCommsTriggerFigure((displayTriggerFigureCheckbox("Communications & Leisure", commsTriggerLimit)));
  }, [sfsTotals.categories.filter((obj) => obj.name === "Communications & Leisure")])

  useEffect(() => {
    setDisplayPersonalTriggerFigure(displayTriggerFigureCheckbox("Personal Costs", personalTriggerLimit))
    setPersonalTriggerLimit(calculateTriggerFigureLimit(household[0].value, household[1].value, household[2].value, clientConfig?.layout?.sfs?.triggerFigures, "Personal Costs"))
  }, [sfsTotals.categories.filter((obj) => obj.name === "Personal Costs")])

  useEffect(() => {
    setDisplayFoodTriggerFigure(displayTriggerFigureCheckbox("Food & Housekeeping", foodTriggerLimit))
    setFoodTriggerLimit(calculateTriggerFigureLimit(household[0].value, household[1].value, household[2].value, clientConfig?.layout?.sfs?.triggerFigures, "Food & Housekeeping"))
  }, [sfsTotals.categories.filter((obj) => obj.name === "Food & Housekeeping")])

  useEffect(() => {
    let disableNextButton = true
    if (commsCheckEnabled && personalCheckEnabled && foodCheckEnabled) {
      disableNextButton = false
    }
    setDisableNext(disableNextButton)
  }, [commsCheckEnabled, personalCheckEnabled, foodCheckEnabled])

  useEffect(() => {
    if (displayCommsTriggerFigure === false) {
      setCommsCheckEnabled(true)
    }
    if (displayCommsTriggerFigure === true) {
      setCommsCheckEnabled(false)
    }
  }, [displayCommsTriggerFigure])

  useEffect(() => {
    if (displayPersonalTriggerFigure === false) {
      setPersonalCheckEnabled(true)
    }
    if (displayPersonalTriggerFigure === true) {
      setPersonalCheckEnabled(false)
    }
  }, [displayPersonalTriggerFigure])

  useEffect(() => {
    if (displayFoodTriggerFigure === false) {
      setFoodCheckEnabled(true)
    }
    if (displayFoodTriggerFigure === true) {
      setFoodCheckEnabled(false)
    }
  }, [displayFoodTriggerFigure])

  return sfsExpenditureFlexible && categories ? (
    <>
      <ScrollToTop />
      <Typography fontSize={22} paddingBottom={2}>
        <b>Expenditure </b> (Flexible)
      </Typography>
      <Stack
        sx={{
          mt: 2,
        }}
        spacing={8}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Box
          id='expenditure-flex-container'
          sx={{ width: { xs: "100%", md: "55%" } }}
        >
          {/* Left column */}
          <Box sx={{ pb: 2 }}>
            {/* Sub category buttons */}
            {categories?.map((category, idx) => {
              return (
                <SfsCategoryButton
                  key={idx}
                  category={category}
                  changeCategory={changeCategory}
                />
              );
            })}
          </Box>
          <Box>
            {/* Sub category Inputs */}
            {sfsExpenditureFlexible?.map((item, idx) =>
              item.category === selectedCategory ? (
                <SfsInputRow
                  key={idx}
                  item={item}
                  setItem={setItem}
                  maxValue={flexValue[item.category]}
                />
              ) : null
            )}
          </Box>
          {/* End of left column */}
        </Box>

        <Box sx={{ width: { xs: "100%", md: "45%" } }}>
          {/* Right column */}

          <SfsSummary id='monthly-expenditure-flex-sum' title={titleText} />

          {/* Call To Action */}
          <Box sx={{ textAlign: "center", pt: 2, pb: 4 }}>
            {
              // Communications & Leisure Trigger Figure
              displayCommsTriggerFigure &&
                (<SfsTriggerFigureCheckbox id={`comms-and-leisure-trigger-figure-checkbox`} expenditureType="Communications & Leisure" triggerSum={commsTriggerLimit} checked={commsCheckEnabled} setChecked={setCommsCheckEnabled} />)
            }
            {
              // Personal Costs Trigger Figure
              displayPersonalTriggerFigure &&
                (<SfsTriggerFigureCheckbox id={`personal-costs-trigger-figure-checkbox`} expenditureType="Personal Costs" triggerSum={personalTriggerLimit} checked={personalCheckEnabled} setChecked={setPersonalCheckEnabled} />)
            }
            {
              // Food & Housekeeping Trigger Figure
              displayFoodTriggerFigure &&
              (<SfsTriggerFigureCheckbox id={`food-and-housekeeping-trigger-figure-checkbox`} expenditureType="Food & Housekeeping" triggerSum={foodTriggerLimit} checked={foodCheckEnabled} setChecked={setFoodCheckEnabled} />)
            }

            <Box sx={{
              pt: 4,
              textAlign: { xs: "center", md: "left" },
              display: "flex",
              flexDirection: "row"
            }}>
              <ActionButton
              id='back-btn'
                borderColor='primary.dark'
                buttonColor='transparent'
                buttonTextColor='primary.dark'
                buttonTitle='Back'
                variant='outlined'
                hoverColor='primary.dark'
                hoverBorderColor={"primary.dark"}
                hoverTextColor='secondary.contrastText'
                onClick={handleBack}
                sx={{ mr: 2 }}
              />
              <ActionButton
                id='save-continue-btn'          
              variant='contained'
                buttonColor='secondary.main'
                buttonTextColor='primary.contrastText'
                borderColor='transparent'
                hoverColor='primary.contrastText'
                hoverBorderColor='secondary.main'
                hoverTextColor='secondary.main'
                buttonTitle='Next'
              disabled={disableNext}
                onClick={handleNext}
              />
            </Box>
          </Box>
          {/* End of right column */}
        </Box>
      </Stack>
    </>
  ) : null;
}

export default SfsExpenditureFlexible;
